import React from 'react';

const SvgRs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="RS_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M.667 3.333c0-.898.498-2.687.498-2.687C1.258.29 1.634 0 1.994 0h2.679a.9.9 0 0 1 .829.642S6 2.413 6 3.333c0 .86-.502 2.693-.502 2.693-.09.354-.358.873-.608 1.137 0 0-.557.837-1.557.837-1 0-1.556-.837-1.556-.837a3.237 3.237 0 0 1-.612-1.146S.667 4.215.667 3.333z"
        id="RS_svg__c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="RS_svg__b" fill="#fff">
        <use xlinkHref="#RS_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#17508F" mask="url(#RS_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#E1444D" mask="url(#RS_svg__b)" d="M0 0h28v6.667H0z" />
      <g mask="url(#RS_svg__b)">
        <g transform="translate(5.333 6.667)">
          <mask id="RS_svg__d" fill="#fff">
            <use xlinkHref="#RS_svg__c" />
          </mask>
          <use fill="#FFF" xlinkHref="#RS_svg__c" />
          <path
            d="M6 .667L.667 7.333"
            stroke="#E1444D"
            strokeWidth={1.333}
            strokeLinecap="square"
            mask="url(#RS_svg__d)"
          />
          <path
            d="M6 .667L.667 7.333"
            stroke="#E1444D"
            strokeWidth={1.333}
            strokeLinecap="square"
            mask="url(#RS_svg__d)"
            transform="matrix(-1 0 0 1 6.667 0)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgRs;
